module.exports={
  "Learn More" : "자세한 정보",
  "CLOSED CAPTION PREVIEW": "선택 자막 미리보기",
  "Sample Text": "샘플 텍스트",
  "Ad": "광고",
  "Skip Ad": "광고 건너뛰기",
  "LIVE": "라이브",
  "GO LIVE": "라이브 방송 시작하기",
  "CC Options": "자막 옵션",
  "On": "켜기",
  "Off": "끄기",
  "Discovery": "디스커버리",
  "Facebook Unavailable": "Facebook 사용 불가",
  "Facebook Success": "Facebook에서 비디오 시청하기",
  "Twitter Unavailable": "Twitter 사용 불가",
  "Twitter Success": "Twitter에서 비디오 시청하기",
  "Post Title": "게시하기",
  "Account Configure": "장치에 계정을 설정해 주십시오",
  "Discover": "디스커버",
  "Up next": "다음 콘텐츠",
  "Video Quality": "비디오 품질",
  "Share": "공유",
  "Start at": "시작 지점:",
  "Embed": "임베드",
  "Email": "이메일",
  "Check out this video": "당신이 흥미로워할 비디오를 찾았어요! 한 번 보세요: ",
  "To": "받는 사람",
  "Subject": "제목",
  "Message": "메시지",
  "name@email.com": "name@email.com",
  "Optional Message": "옵션 메시지",
  "Send": "보내기",
  "RELOAD YOUR SCREEN OR TRY SELECTING A DIFFERENT VIDEO": "화면을 다시 불러오거나 다른 비디오를 선택해 보십시오",
  "THIS IS NOT WORKING! :(": "오류가 있어요! :(",
  "NETWORK ERROR": "네트워크 오류",
  "Cannot Contact Server": "서버 연결 불가",
  "SAS ERROR": "SAS 오류",
  "Invalid Authorization Response": "유효하지 않은 권한 응답",
  "SAS GEO ERROR": "SAS 위치 오류",
  "This video is not authorized in your location": "사용자 위치에서 해당 비디오 접근이 허가되지 않습니다",
  "SAS DOMAIN ERROR": "SAS 도메인 오류",
  "This video is not authorized for your domain": "사용자 도메인에서 해당 비디오 접근이 허가되지 않습니다",
  "VIDEO NOT AVAILABLE YET": "아직 비디오 미출시",
  "This video will be available soon": "비디오가 곧 출시됩니다",
  "VIDEO COMING SOON!": "비디오 출시 임박!",
  "This video is not available yet": "아직 비디오가 출시되지 않았습니다",
  "You may need to refresh the page to access the video after it becomes available" : "비디오 출시 후 페이지를 새로 고쳐야 할 수 있습니다",
  "VIDEO NO LONGER AVAILABLE": "비디오 제공 중단",
  "This video is no longer available": "해당 비디오는 더 이상 제공되지 않습니다",
  "SAS DEVICE ERROR": "SAS 장치 오류",
  "This video is not authorized for playback on this device": "해당 장비에서 해당 비디오 재생이 허가되지 않습니다",
  "SAS PROXY ERROR": "SAS 프록시 오류",
  "An anonymous proxy was detected. Please disable the proxy and retry.": "익명 프록시가 감지되었습니다. 프록시를 비활성화하고 재시도하십시오.",
  "CONCURRENT STREAMS NUMBER EXCEEDED": "동시 스트림 제한 초과",
  "You have exceeded the maximum number of concurrent streams": "최대 허용 동시 스트림 수를 초과했습니다",
  "DEVICE BINDING ERROR": "장치 바인딩 오류",
  "Device binding failed": "장치 바인딩에 실패했습니다",
  "DEVICE ID TOO LONG": "장치 ID 너무 김",
  "Device ID is too long": "장치 ID가 너무 깁니다",
  "INVALID PLAYER TOKEN": "유효하지 않은 플레이어 토큰",
  "Invalid Ooyala Player token": "Ooyala Player Token이 유효하지 않습니다",
  "AUTHORIZATION ERROR": "권한 부여 오류",
  "Unable to register this device to this account, as the maximum number of authorized devices has already been reached. Error Code 22": "권한이 부여된 장치 최대 수에 이미 도달하여 이 장치를 이 계정에 등록할 수 없습니다. 오류 코드 22",
  "Unable to access this content, as the maximum number of devices has already been authorized. Error Code 29": "이미 최대 수의 장치에 권한이 부여되서 이 콘텐츠에 액세스할 수 없습니다.",
  "Please remove one of your authorized devices to enable this device.": "이 장치를 활성화하려면 권한이 부여된 장치 하나를 제거하세요.",
  "LICENSE ERROR": "라이센스 오류",
  "General error acquiring license": "라이센스 획득 관련 일반 오류입니다",
  "DRM SERVER ERROR": "DRM 서버 오류",
  "DRM server error": "DRM 서버 오류입니다",
  "INVALID ENTITLEMENTS ERROR": "유효하지 않은 자격 오류",
  "User Entitlement Terminated - Stream No Longer Active for the User": "사용자 자격 종료 - 사용자의 스트림이 비활성화되었습니다",
  "INVALID HEARTBEAT": "유효하지 않은 심박동",
  "Invalid heartbeat response": "유효하지 않은 심박동 응답입니다",
  "INVALID CONTENT": "유효하지 않은 콘텐츠",
  "INVALID METADATA": "유효하지 않은 메타데이터",
  "Invalid Metadata": "유효하지 않은 메타데이터입니다",
  "PLAYBACK ERROR": "재생 오류",
  "Could not play the content": "콘텐츠를 재생할 수 없었습니다",
  "PLAYBACK STREAM ERROR": "스트림 재생 오류",
  "This video isn't encoded for your device": "해당 비디오는 장치에 맞게 인코딩되지 않았습니다",
  "PLAYBACK LIVESTREAM ERROR": "라이브스트림 재생 오류",
  "Live stream is off air": "라이브 스트림이 중단되었습니다",
  "PLAYBACK NETWORK ERROR": "네트워크 재생 오류",
  "Network connection temporarily lost": "네트워크 연결이 잠시 끊겼습니다",
  "UNPLAYABLE CONTENT ERROR": "재생 불가 콘텐츠 오류",
  "This video is not playable on this player": "해당 장비에서 해당 비디오가 재생되지 않습니다",
  "INVALID EXTERNAL ID": "유효하지 않은 외부 ID",
  "Invalid External ID": "유효하지 않은 외부 ID입니다",
  "EMPTY CHANNEL ERROR": "빈 채널 오류",
  "This channel is empty": "채널이 비었습니다",
  "EMPTY CHANNEL SET ERROR": "빈 채널 세트 오류",
  "This channel set is empty": "해당 채널 세트가 비었습니다",
  "CHANNEL CONTENT ERROR": "채널 콘텐츠 오류",
  "This channel is not playable at this time": "지금 해당 채널을 재생할 수 없습니다",
  "SOMETHING NOT RIGHT! THERE SHOULD BE VIDEOS HERE.": "뭔가 이상해요! 여기 비디오가 있어야 하는데...",
  "(Try Clicking The Discover Button Again On Reload Your Page)": "(디스커버 버튼을 다시 눌러보거나 페이지를 다시 불러오십시오)",
  "Something happened while we were trying to play your video! Click replay or simply reload your page.": "비디오 재생 중에 오류가 발생했습니다! 리플레이를 클릭하거나 그냥 페이지를 다시 불러오십시오",
  "Language": "언어",
  "Color Selection": "색상 선택",
  "Caption Opacity": "자막 불투명도",
  "Font Type": "글꼴 유형",
  "Font Size": "글꼴 크기",
  "Text Enhancements": "텍스트 향상",
  "Text color": "텍스트 색상",
  "Background color": "배경 색상",
  "Window color": "창 색상",
  "Transparent": "투명",
  "White": "흰색",
  "Blue": "파란색",
  "Magenta": "자홍색",
  "Green": "녹색",
  "Yellow": "노란색",
  "Red": "빨간색",
  "Cyan": "청록색",
  "Black": "검은색",
  "Text opacity": "텍스트 불투명도",
  "Background opacity": "배경 불투명도",
  "Window opacity": "창 불투명도",
  "Font size": "글꼴 크기",
  "Small": "소",
  "Medium": "중",
  "Large": "대",
  "Extra Large": "특대",
  "Text enhancement": "텍스트 향상",
  "Uniform": "균일",
  "Depressed": "음각",
  "Raised": "양각",
  "Shadow": "그림자",
  "Play": "재생",
  "Replay": "리플레이",
  "Pause": "일시 중지",
  "Mute": "음소거",
  "Unmute": "음소거 취소",
  "Closed Captions":"선택 자막",
  "Full Screen": "전체 화면",
  "Exit Full Screen": "전체 화면 나가기",
  "More Options": "추가 옵션",
  "Audio": "오디오",
  "Subtitles": "자막",
  "Undefined language": "정의되지 않은 언어",
  "No linguistic content": "언어 콘텐츠 없음",
  "Speed": "속도",
  "Normal": "보통"
}
